import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';
import {User} from '../../models/user.model';
import {UserService} from '../../services/users.service';

@Component({
  providers: [UserService],
  selector: 'app-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent {
  public error: string;
  public user: User;
  public password: string;
  public passwordRepeat: string;

  constructor(private _userService: UserService, private _authService: AuthenticationService, public router: Router) {

  }

  public ngOnInit(): void {
    this.user = this._authService.user;
  }

  public saveUser(): void {
    let valid = true;

    if (this.password === '') {
      this.error = 'Het wachtwoord mag niet leeg zijn.';
      valid = false;
    }

    if (this.password !== this.passwordRepeat) {
      this.error = 'De wachtwoorden komen niet overeen.';
      valid = false;
    }


    if (valid) {
      this.user.password = this.password;
      this._userService.updatePassword(this.user)
        .subscribe(customer => {
          this.router.navigate(['/']);
        });
    }
  }

  public cancel(): void {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.component.ts